export interface TocItem {
  level: 2 | 3;
  text: string;
  anchor: string;
  children?: TocItem[];
}

export function extractToc(markdown: string): TocItem[] {
  if (!markdown) return [];

  // Вырезать содержимое :::name … ::: container directives перед парсингом —
  // иначе заголовки внутри :::tldr (например `## Кратко о главном`) попадают
  // в TOC как дубликат (BUG-LD-008).
  const stripped = markdown.replace(/^:::[\w-]+[\s\S]*?^:::\s*$/gm, '');

  const headings: { level: 2 | 3; text: string; anchor: string }[] = [];
  const lines = stripped.split('\n');

  for (const line of lines) {
    const m = /^(#{2,3})\s+(.+?)(?:\s+\{#([^}]+)\})?$/.exec(line);
    if (!m || !m[1] || !m[2]) continue;
    const level = (m[1].length === 2 ? 2 : 3) as 2 | 3;
    const text = m[2].trim();
    const anchor = m[3]?.trim() || slugify(text);
    headings.push({ level, text, anchor });
  }

  const result: TocItem[] = [];
  for (const h of headings) {
    if (h.level === 2) {
      result.push({ ...h, children: [] });
    } else if (h.level === 3 && result.length > 0) {
      const last = result[result.length - 1];
      if (!last) continue;
      last.children = last.children ?? [];
      last.children.push(h);
    }
  }
  return result;
}

export function slugify(text: string): string {
  return (
    text
      .toLowerCase()
      .replace(/[^\p{L}\p{N}\s-]/gu, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 64) || 'section'
  );
}
